import { Actions, Mutations } from '@/util/settings/enums';
const actions = {
    async [Actions.FETCH_CONTENT]({ commit, state }) {
        try {
            const { language } = state;
            console.log(language);
            const languageContent = await import('@/store/content/language');
            commit(Mutations.SET_CONTENT, languageContent.default);
            console.log('%c CONTENT ', 'background: #ffedb9; color: #1e8bc3; padding: .5rem;');
            console.log(languageContent.default);
        }
        catch (error) {
            console.log(error);
        }
    }
};
export default actions;
